import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type AvailableAdvanceParamsT = {
  company_id: string;
  currency: string;
  order_id: string;
};

export type AvailableAdvanceT = {
  params: AvailableAdvanceParamsT;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  params,
  errorCallback = () => {},
  successCallback = () => {},
  resultKey = 'availableAdvanceData',
}: AvailableAdvanceT) =>
  requestAsync({
    url: endpoints.getAvailableAdvanceUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getAvailableAdvanceUrl(params),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
